/**
 * GA4 Custom Event Tracking
 * Works with Google & YouTube app's gtag implementation
 */
(function() {
  'use strict';

  // Check if gtag is available (loaded by Google & YouTube app)
  function trackEvent(eventName, params) {
    if (typeof gtag === 'undefined') {
      console.warn('GA4: gtag not loaded yet');
      return;
    }
    gtag('event', eventName, params || {});
  }

  // === CALCULATOR EVENTS ===

  window.trackCalculatorStarted = function(calculatorType, method) {
    trackEvent('calculator_started', {
      calculator_type: calculatorType,
      calculation_method: method
    });
  };

  window.trackCalculatorResult = function(calculatorType, productHandle, zodiacOrPurpose) {
    trackEvent('calculator_result_viewed', {
      calculator_type: calculatorType,
      recommended_product: productHandle,
      selection: zodiacOrPurpose
    });
  };

  window.trackCalculatorAddToCart = function(calculatorType, productName, productId) {
    trackEvent('calculator_add_to_cart', {
      calculator_type: calculatorType,
      product_name: productName,
      product_id: productId
    });
  };

  // === USER INTERACTION EVENTS ===

  window.trackWhatsAppClick = function() {
    trackEvent('whatsapp_click', {
      button_location: 'float_button'
    });
  };

  window.trackSocialClick = function(platform, location) {
    trackEvent('social_click', {
      platform: platform,
      location: location
    });
  };

  window.trackFAQOpened = function(question, section) {
    trackEvent('faq_opened', {
      question_title: question,
      section_name: section || 'general'
    });
  };

  window.trackNewsletterSignup = function(source) {
    trackEvent('newsletter_signup', {
      form_location: source
    });
  };

  window.trackSearch = function(searchTerm) {
    trackEvent('search_used', {
      search_term: searchTerm
    });
  };

  // === PRODUCT ENGAGEMENT EVENTS ===

  window.trackProductImageClick = function(productName, imageIndex) {
    trackEvent('product_image_clicked', {
      product_name: productName,
      image_index: imageIndex
    });
  };

  window.trackVariantChange = function(productName, variantName) {
    trackEvent('variant_changed', {
      product_name: productName,
      variant_selected: variantName
    });
  };

  window.trackSizeGuideOpened = function(productName) {
    trackEvent('size_guide_opened', {
      product_name: productName
    });
  };

  // === NAVIGATION EVENTS ===

  window.trackViewAllClick = function(sectionName) {
    trackEvent('view_all_clicked', {
      section_name: sectionName
    });
  };

  window.trackMenuClick = function(menuItem, submenu) {
    trackEvent('menu_clicked', {
      menu_item: menuItem,
      submenu_item: submenu || ''
    });
  };

  // === SCROLL DEPTH TRACKING ===

  (function initScrollTracking() {
    const depths = [25, 50, 75, 100];
    const tracked = {};

    window.addEventListener('scroll', function() {
      const scrollPercent = Math.round((window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100);

      depths.forEach(function(depth) {
        if (scrollPercent >= depth && !tracked[depth]) {
          tracked[depth] = true;
          trackEvent('scroll_depth', {
            page_type: document.body.className.match(/template-(\S+)/)?.[1] || 'unknown',
            scroll_percentage: depth
          });
        }
      });
    });
  })();

})();
